import React from "react";
import { Chip } from "@mui/material";
import type { PageStatus } from "../../../types/cms";

interface CmsStatusBadgeProps {
  status: PageStatus;
  markDel: boolean;
}

const CmsStatusBadge: React.FC<CmsStatusBadgeProps> = ({ status, markDel }) => {
  if (markDel) {
    return <Chip size="small" label="Archived" color="default" />;
  }
  if (status === "published") {
    return <Chip size="small" label="Published" color="success" />;
  }
  return <Chip size="small" label="Draft" color="warning" />;
};

export default CmsStatusBadge;
